import { Theme } from '@dhl/theme'
import {
  BigTruck,
  Pallet,
  ParcelTypesMedium,
  ServicePoint,
  Truck,
  PrintlessGoGreen,
  LabelPrinter,
} from '@dhl/illustrations'

export type IconName =
  | 'BigTruck'
  | 'Pallet'
  | 'ParcelTypesMedium'
  | 'ServicePoint'
  | 'Truck'
  | 'PrintlessGoGreen'
  | 'LabelPrinter'

type Props = {
  name: IconName
}

export const SelectableCardIcon = ({ name }: Props) => {
  const iconSx = ({ breakpoints: { down, up } }: Theme) => ({
    [down('xs')]: { width: '70px', height: '60px' },
    [up('sm')]: { width: '80px', height: '70px' },
  })

  switch (name) {
    case 'BigTruck':
      return <BigTruck sx={iconSx} />
    case 'Pallet':
      return <Pallet sx={iconSx} />
    case 'ParcelTypesMedium':
      return <ParcelTypesMedium sx={iconSx} />
    case 'ServicePoint':
      return <ServicePoint sx={iconSx} />
    case 'Truck':
      return <Truck sx={iconSx} />
    case 'PrintlessGoGreen':
      return <PrintlessGoGreen sx={iconSx} />
    case 'LabelPrinter':
      return <LabelPrinter sx={iconSx} />
    default:
      return null
  }
}
